module.exports = __webpack_public_path__ + "img/LV23.7ed6cb1f.png";